module.exports = __webpack_public_path__ + "img/root011.9b07b70a.png";